import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
  IMPORT_SCHEDULES_TEMPLATE_URL,
  IMPORT_XLS_SIZE_2MB,
  IMPORT_FILE,
} from '../../constants';
import { schedulesService } from '../../services';

const ImportSchedules = ({ handleReFetchEvents }) => {
  const fileInputRef = useRef();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [inputFile, setInputFile] = useState(null);

  useEffect(() => {
    setInputFile(document.getElementById('schedulesUpload'));
  }, []);

  const handleUpload = () => {
    inputFile?.click();
  };

  const uploadFile = (event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      const { files } = event.target;
      if (!files[0].name.match(/.(xls|xlsx|ods)$/i)) {
        toast.error(IMPORT_FILE.XLS_TYPE);
        return;
      }

      if (files[0].size > IMPORT_XLS_SIZE_2MB) {
        toast.error(IMPORT_FILE.XLS_SIZE);
        return;
      }
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        schedulesService
          .import_schedules({
            teamOwnerId: localStorage.getItem('teamOwnerId'),
            file: reader.result,
          })
          .then((response) => {
            setSubmitting(false);
            document.getElementById('schedulesUpload').value = null;
            if (response.status) {
              if (response.message === 'Success') {
                toast.success(`Successfully imported schedules`);
              } else {
                toast.success(response.message);
              }
              handleReFetchEvents(true);
            }
            handleClose();
          })
          .catch((errResp) => {
            if (errResp.data) {
              toast.error(errResp.data);
            } else {
              toast.error('Some error occurred while importing this data.');
            }
            if (fileInputRef?.current) {
              fileInputRef.current.value = '';
            }
            setSubmitting(false);
            handleClose();
          });
      }; // end of file reader
    } // end if
  }; // end upload file
  const handleUploadClick = (values) => {
    setSubmitting(true);
    uploadFile(values);
  };
  return (
    <>
      <input
        ref={fileInputRef}
        className="d-none"
        type="file"
        name="schedules"
        id="schedulesUpload"
        accept=".xls, .xlsx"
        onChange={handleUploadClick}
      />
      <Dropdown.Item onClick={handleShow}>Import Schedule</Dropdown.Item>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="pt-4" closeButton>
          <Modal.Title>Import Schedule</Modal.Title>
        </Modal.Header>
        <Formik>
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body>
                <section>
                  <Form.Group controlId="description">
                    <Form.Label className="text-muted text-center">
                      Please upload an Excel file containing schedule details in
                      the specified template format&nbsp;
                      <Link
                        to={{
                          pathname: `${IMPORT_SCHEDULES_TEMPLATE_URL}`,
                        }}
                        target="_blank"
                        download
                      >
                        (Import Schedules Template)
                      </Link>
                    </Form.Label>
                  </Form.Group>
                  <Form.Group controlId="description" className="text-center">
                    <input
                      className="d-none"
                      type="file"
                      name="schedules"
                      id="schedulesUpload"
                      accept=".xls, .xlsx"
                      onChange={uploadFile}
                    />
                    {isSubmitting ? (
                      <Button variant="primary" className="me-2" disabled>
                        Importing schedules...
                      </Button>
                    ) : (
                      <Button
                        onClick={handleUpload}
                        variant="primary"
                        className="me-2"
                      >
                        Upload File
                      </Button>
                    )}
                  </Form.Group>
                </section>
              </Modal.Body>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

ImportSchedules.propTypes = {
  handleReFetchEvents: PropTypes.func,
};

export default ImportSchedules;
